import { UnitEnumType } from '../generated/graphql';

export function formatAmount(value: number, unit: string = '', decimals: number = 2, enforceDecimals = false) {
  let formattedValue: any = Math.round(value * 10 ** decimals) / 10 ** decimals;
  if (enforceDecimals) {
    formattedValue = formattedValue.toFixed(decimals);
  } else {
    formattedValue = formattedValue.toString();
  }
  return `${formattedValue.replace('.', ',')}${unit ? unit : ''}`;
}

export function formatTemperature(value: number) {
  return formatAmount(value, '°C');
}

export function formatPercentage(value: number) {
  return formatAmount(value * 100, '%');
}

export function formatProductUnitAmount(amount: number, unitType: UnitEnumType) {
  if (unitType === UnitEnumType.Unit) {
    return `${amount.toString(10)}x`;
  }

  let value = amount;
  if (amount > 1000) {
    value = amount / 1000;
  }

  let suffix = '';
  if (unitType === UnitEnumType.Liter) {
    suffix = amount > 1000 ? 'l' : 'cl';
  } else {
    suffix = amount > 1000 ? 'kg' : 'g';
  }

  return formatAmount(value, suffix, 2, amount > 1000);
}
